import { render, staticRenderFns } from "./TrafficPoolEdit.vue?vue&type=template&id=35c9508a&scoped=true&"
import script from "./TrafficPoolEdit.vue?vue&type=script&lang=js&"
export * from "./TrafficPoolEdit.vue?vue&type=script&lang=js&"
import style0 from "./TrafficPoolEdit.vue?vue&type=style&index=0&id=35c9508a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9508a",
  null
  
)

export default component.exports